import validate from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.11.2_@opentelemetry+api@1.9.0_@parcel+watcher@2.4.1_@types+node@20.12.12_@unocss_21a67b4bf6eccfa6f22a394129997420/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-only": () => import("/app/middleware/adminOnly.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "booster-only": () => import("/app/middleware/boosterOnly.ts"),
  "customer-only": () => import("/app/middleware/customerOnly.ts"),
  "load-game": () => import("/app/middleware/loadGame.ts")
}